import { useTranslation } from 'react-i18next'
import capitalize from 'lodash/capitalize'

import type { StatusBadgeProps } from './StatusBadge.types'

const StatusBadge = (props: StatusBadgeProps) => {
  const { status } = props
  const { t } = useTranslation()

  const getClasses = () => {
    const statusClasses: Record<string, string> = {
      active: 'bg-green-100 text-green-800',
      inactive: 'bg-red-100 text-red-800',
      planned: 'bg-yellow-100 text-yellow-800',
    }

    const validStatus = statusClasses[status.toLowerCase()]

    return validStatus || 'bg-gray-100 text-gray-800'
  }

  const getTranslationKey = () => {
    return `Tenants.Status.${capitalize(status)}`
  }

  return (
    <span
      className={`px-2 py-1 rounded-full text-xs font-medium ${getClasses()}`}
    >
      {t(getTranslationKey())}
    </span>
  )
}

export default StatusBadge
